import { useState } from 'react';
import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { OverlayView, TOverlayView } from './constants';

interface IDatePickerNavigationProps {
  date: Date,
  changeMonth: ReactDatePickerCustomHeaderProps['changeMonth'],
  changeYear: ReactDatePickerCustomHeaderProps['changeYear'],
  minDate?: Date | null,
  maxDate?: Date | null,
}

const useDatePickerNavigation = ({ date, changeMonth, changeYear, minDate, maxDate }: IDatePickerNavigationProps) => {
  const [overlayView, setOverlayView] = useState<TOverlayView>(OverlayView.None);

  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();

  const toggleMonthOverlay = () => {
    setOverlayView((prev) => (prev === OverlayView.Month ? OverlayView.None : OverlayView.Month));
  };

  const toggleYearOverlay = () => {
    setOverlayView((prev) => (prev === OverlayView.Year ? OverlayView.None : OverlayView.Year));
  };

  const selectMonth = (month: number): void => {
    changeMonth(month);
    setOverlayView(OverlayView.None);
  };

  const navigateToYear = (year: number): void => {
    changeYear(year);
    if (minDate && year === minDate.getFullYear() && currentMonth < minDate.getMonth()) {
      changeMonth(minDate.getMonth());
    }
    if (maxDate && year === maxDate.getFullYear() && currentMonth > maxDate.getMonth()) {
      changeMonth(maxDate.getMonth());
    }
  };

  const selectYear = (year: number): void => {
    navigateToYear(year);
    setOverlayView(OverlayView.None);
  };

  const decreaseYear = (): void => navigateToYear(currentYear - 1);
  const increaseYear = (): void => navigateToYear(currentYear + 1);

  return {
    overlayView,
    currentMonth,
    currentYear,
    toggleMonthOverlay,
    toggleYearOverlay,
    selectMonth,
    selectYear,
    decreaseYear,
    increaseYear,
  };
};

export default useDatePickerNavigation;
